module.exports = __webpack_public_path__ + "img/icon-topper-dark.2f2873e9.svg";